import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import UnsubscribeApp from './UnsubscribeApp';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <Switch>
            <Route exact path="/unsubscribe" component={UnsubscribeApp} />
            <Route path="*" component={App} />
        </Switch>
    </BrowserRouter>,
    rootElement);

registerServiceWorker();